// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".-K\\+j-{position:relative;margin:0 0 32px}@media screen and (min-width:768px){.-K\\+j-{margin:0 0 40px}}.-K\\+j-:after{display:block;padding-bottom:56.25%;content:\"\"}.-K\\+j->iframe{position:absolute;top:0;left:0;width:100%;height:100%;border:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"articleVideo": "-K+j-"
};
module.exports = ___CSS_LOADER_EXPORT___;
